import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { MainButton } from 'components/button'
import { Tooltip } from 'components/tooltip'

import styles from './teach_mode.scss'

import helpIcon from 'assets/components/teach_modes/help.svg'

const TeachMode = props => (
	<div styleName='teach-mode'>
		<div styleName='teach-mode-top'>
			<Isvg src={props.image} cacheGetRequests={true} styleName='teach-mode-image'/>
			<div styleName='teach-mode-help'>
				<div styleName='teach-mode-help-tooltip'>
					<Tooltip arrow={'bottom-right'}>
						{props.tooltip}
					</Tooltip>
				</div>
				<Isvg src={helpIcon} cacheGetRequests={true} styleName='teach-mode-help-icon'/>
			</div>
		</div>
		<div styleName='teach-mode-bottom'>
			<MainButton
				onClick={props.buttonAction}
			>
				{props.buttonText}
			</MainButton>
			{props.shouldShowLink &&
				<div
					styleName='teach-mode-link'
					onClick={props.linkAction}
				>
					{props.linkText}
				</div>
			}
		</div>
	</div>
)

TeachMode.propTypes = {
	image: PropTypes.string.isRequired,
	buttonAction: PropTypes.func,
	buttonText: PropTypes.string,
	tooltip: PropTypes.string,
	shouldShowLink: PropTypes.bool,
	linkText: PropTypes.string,
	linkAction: PropTypes.func,
}

TeachMode.defaultProps = {
	buttonAction: () => {},
	buttonText: '',
	tooltip: '',
	shouldShowLink: false,
	linkText: '',
	linkAction: () => {},
}

export default CSSModules(TeachMode, styles, {allowMultiple: true})


